import { ListFilter } from 'lucide-react';
import { useState } from 'react';
import { useFilterV3Context } from '../../contexts/FilterV3.context';
import FilterButton from '../FilterButton/FilterButton';

interface AddFiltersButtonProps {
  label: string;
  testId?: string;
}

const AddFiltersButton = ({ label, testId }: AddFiltersButtonProps) => {
  const { onChangeAnchorEl, anchorEl } = useFilterV3Context();
  const [triggerElement, setTriggerElement] = useState<HTMLButtonElement | null>(null);

  const handleOpenMenu = () => {
    if (!triggerElement) {
      return;
    }

    onChangeAnchorEl(triggerElement);
  };

  const isActive = !!anchorEl && anchorEl === triggerElement;

  return (
    <FilterButton
      ref={setTriggerElement}
      label={label}
      icon={ListFilter}
      onClick={handleOpenMenu}
      testId={testId}
      isActive={isActive}
    />
  );
};

export default AddFiltersButton;
